/* S1 Metals Elements
   - fade-ins: .s1-me-fade + IntersectionObserver (same contract as the other
     s1 landing sections)
   - showcase video: plays only while >=50% in view, pauses off-screen
     (MetalsElements.tsx behaviour — stays observed, unlike the fades)
   - CTA: [data-me-scroll]; "product" falls back to the first <s1-pdp> */

class S1MetalsElements extends HTMLElement {
  connectedCallback() {
    if (!this._fadeIo) {
      this._fadeIo = new IntersectionObserver((entries) => {
        entries.forEach((en) => {
          if (en.isIntersecting) {
            en.target.classList.add('is-visible');
            this._fadeIo.unobserve(en.target);
          }
        });
      }, { threshold: 0.2 });
    }
    this.querySelectorAll('.s1-me-fade:not(.is-visible)').forEach((el) => this._fadeIo.observe(el));

    const video = this.querySelector('[data-me-video]');
    if (video && !this._videoIo) {
      this._videoIo = new IntersectionObserver((entries) => {
        entries.forEach((en) => {
          if (en.isIntersecting) video.play().catch(() => {});
          else video.pause();
        });
      }, { threshold: 0.5 });
      this._videoIo.observe(video);
    }

    if (this._bound) return;
    this._bound = true;
    this.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-me-scroll]');
      if (!btn) return;
      const target = btn.dataset.meScroll;
      const el = document.getElementById(target)
        || (target === 'product' && document.querySelector('s1-pdp'));
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    });
  }

  disconnectedCallback() {
    if (this._fadeIo) this._fadeIo.disconnect();
    if (this._videoIo) { this._videoIo.disconnect(); this._videoIo = null; }
  }
}

if (!customElements.get('s1-metals-elements')) {
  customElements.define('s1-metals-elements', S1MetalsElements);
}
